// src/util/checkoutContext.js
// Mirror of server/api-util/checkoutContext.js (server is CommonJS, client is
// ESM, so the small vocabulary is intentionally duplicated). Keep in sync.
export const ORIGIN_CONTEXT = { APP: 'app', WEB: 'web' };

export const CHECKOUT_TYPE = {
  DIRECT: 'direct',
  UPSELL: 'upsell',
  UPGRADE: 'upgrade',
  RENEWAL: 'renewal',
  FLEX_PASS: 'flex_pass',
  // 25Pass subscriber switching to a full annual pass. The running 25Pass
  // subscription is canceled (no refund) once the new pass has been paid.
  PASS_CHANGE: 'pass_change',
};

// Legacy origin_context values, for the dual-read fallback on Stripe return URLs.
// TODO(checkout-metadata): remove after 2026-07-10.
export const LEGACY_ORIGIN_CONTEXT = {
  [CHECKOUT_TYPE.UPSELL]: 'checkout-upsell',
  [CHECKOUT_TYPE.UPGRADE]: 'checkout-pass-upgrade',
  [CHECKOUT_TYPE.RENEWAL]: 'next_subscription_period',
  [CHECKOUT_TYPE.FLEX_PASS]: 'flex_pass',
};

// True when the return URL's search params identify the given flow, matching
// the new `checkout_type` param or the legacy `origin_context` param.
export const matchesCheckoutType = (searchParams, type) =>
  searchParams.get('checkout_type') === type ||
  (LEGACY_ORIGIN_CONTEXT[type] !== undefined &&
    searchParams.get('origin_context') === LEGACY_ORIGIN_CONTEXT[type]);

// Where a checkout was started from (`source` query param). Allowlist only —
// the server writes it to Stripe metadata as `checkout_source`.
export const CHECKOUT_SOURCE = { ONESIGNAL_IAM: 'onesignal_iam' };

const CHECKOUT_CAMPAIGN_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

export const isCheckoutSource = (value) => Object.values(CHECKOUT_SOURCE).includes(value);

// Free-form campaign id (`campaign` query param), `checkout_campaign` metadata.
export const isCheckoutCampaign = (value) =>
  typeof value === 'string' && CHECKOUT_CAMPAIGN_PATTERN.test(value);
